// extracted by mini-css-extract-plugin
module.exports = {"input":"salePage_input__2d5tt","comment":"salePage_comment__2Vlku","select":"salePage_select__FJfPC"};